import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { AgendaDto, AgendaServiceProxy, AnexoConsultaDto, ConsultaServiceProxy, ConvenioDto, ConvenioServiceProxy, CreateConsultaDto, CreateSimplePacienteDto, DiaLivreDto, EssentialProfisisonalSaudeDto, EventoServiceProxy, HorarioLivreDto, PacienteDto, PacienteGroupDto, TipoConsultaEnum, TipoUsuarioEnum } from '@shared/service-proxies/service-proxies';
import { TipoConsultaList } from "@shared/model/tipo-consulta-enum.model";
import { TipoArquivoProntuarioList } from "@shared/model/tipo-arquivo-prontuario-enum.model";
import { StringUtils } from '@shared/helpers/StringUtils';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { DataService } from '@shared/services/data.service';
import { CustomDatepickerSelectedComponent } from '@shared/components/custom-datepicker-selected/custom-datepicker-selected.component';
import { Router } from '@node_modules/@angular/router';

@Component({
  selector: 'app-create-consulta',
  templateUrl: './create-consulta.component.html',
  styleUrls: ['./create-consulta.component.scss'],
})
export class CreateConsultaComponent extends AppComponentBase implements OnInit {

  public consulta: CreateConsultaDto = new CreateConsultaDto();
  public convenios: ConvenioDto[] = [];
  public pacientesFiltrados: PacienteGroupDto[] = [];
  public pacientesSelecionado: PacienteGroupDto;
  public profissionaisFiltrados: EssentialProfisisonalSaudeDto[] = [];
  public profisionalSelecionado: EssentialProfisisonalSaudeDto = new EssentialProfisisonalSaudeDto();
  public tipoConsulta: TipoConsultaList = new TipoConsultaList();
  public tipoArquivo: TipoArquivoProntuarioList = new TipoArquivoProntuarioList();
  public saving: boolean = false;
  public horaConsulta: string;
  public dataConsulta: string;
  public dataAtual: string = moment().format("YYYY-MM-DD");
  public diasDisponiveis: string[] = [];
  public horariosDisponiveis: HorarioLivreDto[] = [];
  protected agendas: AgendaDto[] = [];
  protected horarioSelecionado: HorarioLivreDto = new HorarioLivreDto();
  protected isDisebled: boolean = true;
  protected cadastrarNovoPaciente: boolean = false;
  private datasDisponivies: DiaLivreDto[] = [];
  private availableDates: Date[];

  @Input() pacientes: PacienteGroupDto[] = [];
  @Input() profissionais: EssentialProfisisonalSaudeDto[] = [];
  @Input() tipoUsuario: TipoUsuarioEnum;
  @Output() onSave = new EventEmitter<any>();

  @ViewChild('file') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('datePicker') datePickerInput!: CustomDatepickerSelectedComponent;

  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy,
    private readonly _convenioService: ConvenioServiceProxy,
    private readonly _eventoService: EventoServiceProxy,
    private readonly _dataService: DataService,
    private readonly _agendaService: AgendaServiceProxy,
    private router: Router,
    private _cdr: ChangeDetectorRef
  ) { super(injector) }


  ngOnInit(): void {
    this.getConvenios();
    this.consulta.convenioId = null;
    this.consulta.novoPaciente = new CreateSimplePacienteDto();
    this.consulta.anexos = [];
    this.consulta.clinicaMedicaId = this.appSession.clinicaId;
    this.pacientesFiltrados = [...this.pacientes];
    if (this.profissionais.length > 1) {
      this.profissionaisFiltrados = [...this.profissionais]
    } else {
      this.profissionaisFiltrados = [];
      this.profisionalSelecionado = this.profissionais[0];
      this.consulta.profissionalId = this.profissionais[0].id;
      this.isDisebled = false;
      this.getAgenda();
    }

    if (this.consulta.dataConsulta) {
      const base = moment(this.consulta.dataConsulta);

      const primeiroDiaMes = base.clone().startOf('month').startOf('day');
      const ultimoDiaMes = base.clone().endOf('month').endOf('day');

      this.getDatasDisponiveis(
        moment(primeiroDiaMes.format('DD/MM/YYYY'), 'DD/MM/YYYY'),
        moment(ultimoDiaMes.format('DD/MM/YYYY'), 'DD/MM/YYYY'),
        true
      );
    }

  }

  protected save(): void {
    if (this.saving) return;
    this.saving = true;
    this.consulta.dataConsulta = this._dataService.combinarDataHora(this.dataConsulta, this.horaConsulta)
    if (!this.IsFormValided()) {
      this.saving = false;
      return;
    }
    abp.ui.setBusy();
    this.consulta.clinicaMedicaId = this.appSession.clinicaId;

    if (StringUtils.isNullOrEmpty(this.consulta.pacienteId)) {
      this.consulta.novoPaciente.clinicaMedicaId = this.consulta.clinicaMedicaId;
      if (!this.appSession.clinicaId)
        this.consulta.novoPaciente.profissionalId = this.consulta.profissionalId;
    }

    this._consultaService.create(this.consulta).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    })
  }

  protected atualizarListaPacientes(event: Event): void {
    const nome = (event.target as HTMLInputElement).value?.trim().toLowerCase();

    this.pacientesFiltrados = nome
      ? this.pacientes.filter(p => p.nome.toLowerCase().includes(nome))
      : [...this.pacientes];
  }


  protected selecionarPaciente(paciente?: PacienteGroupDto): void {
    this.pacientesSelecionado = paciente;
    this.consulta.pacienteId = paciente?.id;
    this.consulta.novoPaciente = null;
  }

  protected atualizarListaProfissionais(event: Event): void {
    const nome = (event.target as HTMLInputElement).value?.trim().toLowerCase();

    this.pacientesFiltrados = nome
      ? this.pacientes.filter(p => p.nome.toLowerCase().includes(nome))
      : [...this.pacientes];
  }

  protected selecionarProfisional(profissional?: EssentialProfisisonalSaudeDto): void {
    this.profisionalSelecionado = profissional;
    this.consulta.profissionalId = profissional?.id;
    if (profissional) {
      this.getAgenda();
    }
  }

  protected selecionarAgenda(): void {
    if (this.consulta.agendaId) {
      this.getDatasDisponiveis(moment().startOf('month'), moment().endOf('month'));
      this.isDisebled = false;
    }
    else {
      this.isDisebled = true;
    }
    if (this.datePickerInput?.dataConsulta) this.datePickerInput.dataConsulta = null;
    this.horariosDisponiveis = [];
    this.diasDisponiveis = [];
  }

  protected IsFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.consulta.descricao), message: "Informe a descrição da consulta." },
      { condition: StringUtils.isNullOrEmpty(this.dataConsulta), message: "Informe a data da consulta." },
      { condition: StringUtils.isNullOrEmpty(this.horaConsulta), message: "Informe o horário da consulta." },
      { condition: StringUtils.isNullOrEmpty(this.consulta.pacienteId) && StringUtils.isNullOrEmpty(this.consulta.novoPaciente.cpf), message: "Informe o paciente." },
      { condition: StringUtils.isNullOrEmpty(this.consulta.profissionalId), message: "Informe o profissional." },
      { condition: !this.consulta.tipoConsulta, message: "Informe o tipo da consulta." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  protected updateFileList(files: AnexoConsultaDto[]): void {
    this.consulta.anexos = [...files];
  }

  protected getHorariosDisponiveis(setHorario: boolean = false): void {
    this.horariosDisponiveis = this.datasDisponivies.find(x => x.data.format("DD/MM/YYYY") == this.dataConsulta).horarios;
    if (setHorario) {
      const horaConsulta = this.consulta.dataConsulta.format('HH:mm')
      this.horarioSelecionado = this.horariosDisponiveis.find(x => x.horaInicio == horaConsulta);
      this.setHorario();
    }
  }

  protected setHorario(): void {
    this.horaConsulta = this.horarioSelecionado.horaInicio;
    this.consulta.agendaId = this.horarioSelecionado.agendaId;
  }

  protected setDataConsulta(data: string, dataFormatada: boolean = false): void {
    this.horariosDisponiveis = [];
    if (dataFormatada) this.dataConsulta = data;
    else this.dataConsulta = moment(data).format("DD/MM/YYYY");
    this.getHorariosDisponiveis(dataFormatada);
  }

  protected atualizarDatasDisponiveis(datas: moment.Moment[]): void {
    if (datas)
      this.getDatasDisponiveis(datas[0], datas[1]);
  }

  private getDatasDisponiveis(dataInicio: moment.Moment, dataFim: moment.Moment, setHorarios: boolean = false): void {
    abp.ui.setBusy();
    this._eventoService.getHorariosDisponiveisPorDia(this.consulta.profissionalId, this.appSession.clinicaId, dataInicio, dataFim, this.consulta.agendaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.datasDisponivies = result;
      const mapa = new Map<string, moment.Moment>();

      for (const item of result) {
        const dataChave = item.data.format('YYYY-MM-DD');
        if (!mapa.has(dataChave)) {
          mapa.set(dataChave, item.data);
        }
      }
      let datas = Array.from(mapa.values()).map(m => m.format('DD/MM/YYYY'))
      this.availableDates = datas.map(dateStr => {
        const [day, month, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day);
      });
      this.datePickerInput.updateDatas(this.availableDates);
      if (setHorarios) {
        this.setDataConsulta(this.consulta.dataConsulta.format('DD/MM/YYYY'), true);
      }
    });
  }

  protected getConvenios(): void {
    abp.ui.setBusy();
    this._convenioService.getConvenios().pipe(
      finalize(() => {
        abp.ui.clearBusy()
      })
    ).subscribe((result) => {
      this.convenios = result;
    })
  }

  protected changeNovoPaciente(): void {
    this.cadastrarNovoPaciente = !this.cadastrarNovoPaciente;
    this.consulta.novoPaciente = new CreateSimplePacienteDto();
  }

  protected getAgenda(): void {
    abp.ui.setBusy();
    this._agendaService.getAgendaProfissional(this.consulta.profissionalId, this.appSession.clinicaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.agendas = result;
    });
  }

  protected criarAgenda() {
    if (this.appSession.userHasRole('Clinica'))
      this.router.navigate(['app', 'clinica', "agenda"]);
    if (this.appSession.userHasRole('Funcionario'))
      this.router.navigate(['app', 'funcionario', "agenda"]);
    if (this.appSession.userHasRole('ProfissionalSaude'))
      this.router.navigate(['app', 'profissional-saude', "minha-agenda"]);

    this.bsModalRef.hide();
  }
}
